<template>
  <ContractCreateWrapper
    :next-btn-disabled="nextIsDisabled"
    :next-btn-name="nextName"
    :next-btn-loading="loading"
    :prev-btn-show="[1, 2].indexOf(this.step) > -1"
    :title="title"
    class-name="contract-create"
    @on-next-btn-click="handleSubmit"
    @on-prev-btn-click="handlePrevStep">
    <v-loading :loading="loading"></v-loading>
    <!--步骤一-->
    <template v-if="step === 0">
      <CreateTitle :num="1" title="客户信息与服务录入"></CreateTitle>
      <Form :model="formData"
            label-position="top"
            ref="form0"
            :rules="rules">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="username"
                      label="客户账号">
              <Input type="text"
                     :disabled="usernameLoading"
                     placeholder="用户名/手机号/邮箱"
                     v-model="formData.username">
                <Icon type="ios-loading"
                      style="animation: input-loading 1s linear infinite;"
                      v-if="usernameLoading"
                      slot="suffix" />
              </Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="customerCompany" label="公司备注">
              <Input type="text"
                     placeholder="公司信息"
                     :maxlength="20"
                     v-model="formData.customerCompany"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="appId" label="购买服务类型">
              <Select v-model="formData.appId"
                      placeholder="请选择服务类别">
                <Option :value="item.id"
                        v-for="item in appList"
                        :key="item.id">{{item.app_name}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="contractType" label="计费方式">
              <Select v-model="formData.contractType"
                      placeholder="请选择计费方式">
                <Option v-for="item in contractTypeList"
                        :key="item.key"
                        :value="item.key">{{item.value}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </template>
    <!--步骤二-->
    <template v-if="step === 1">
      <CreateTitle :num="2" :title="secondTitle"></CreateTitle>
      <!--免费合同-->
      <Form :model="formData"
            v-if="formData.contractType === 'FREE'"
            label-position="top"
            ref="form1"
            :rules="rules">
        <Row :gutter="40" key="free-form-item">
          <Col :span="12">
            <FormItem prop="startTime"
                      label="服务开始时间">
              <DatePicker style="width: 100%"
                          transfer
                          :options="startTimeOption"
                          v-model="formData.startTime"
                          placeholder="请选择服务开始时间（年-月-日）"></DatePicker>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem prop="offlineContractNumber"
                      label="线下合同编号">
              <Input type="text"
                     :maxlength="20"
                     placeholder="输入编号，例如TS837377747484"
                     v-model="formData.offlineContractNumber"></Input>
            </FormItem>
          </Col>
        </Row>
        <FormItem prop="reasonForTrial" label="申请试用原因">
          <Input type="textarea"
                 :rows="10"
                 placeholder="在这里输入正文…"
                 v-model="formData.reasonForTrial">
          </Input>
        </FormItem>
      </Form>
      <!--月结合同-->
      <Form :model="formData"
            v-else-if="formData.contractType === 'MONTHLY'"
            label-position="top"
            ref="form1"
            :rules="rules">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="count"
                      label="每月调用次数（只能为整数）">
              <v-format-input v-model="formData.count"
                         type="text"
                         placeholder="输入数字，例如10000">
                <span slot="append">次</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="qps" label="QPS限额">
              <Select v-model="formData.qps"
                      transfer
                      placeholder="请选择最大QPS限额">
                <Option value="1">1</Option>
                <Option value="5">5</Option>
                <Option value="10">10</Option>
                <Option value="20">20</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="startTime"
                      label="服务开始时间">
              <DatePicker style="width: 100%"
                          type="month"
                          transfer
                          :options="monthStartTimeOption"
                          v-model="formData.startTime"
                          placeholder="请选择服务开始时间（年-月）"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="month" label="持续月份">
              <v-format-input type="text"
                     placeholder="请输入持续月份"
                     v-model="formData.month">
                <span slot="append">月</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="amount" label="每月套餐费用（只能为整数）">
              <v-format-input style="width: 100%"
                              format="positiveIntegerAndZero"
                              v-model="formData.amount"
                              placeholder="输入数字，例如50000">
                <span slot="append">元整</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="excessFees" label="超额单次费用（可以有小数）">
              <v-format-input format="money"
                              v-model="formData.excessFees"
                              placeholder="输入数字，例如1.1">
                <span slot="append">元/次</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="offlineContractNumber" label="线下合同编号">
              <Input type="text"
                     :maxlength="20"
                     placeholder="输入编号，例如TS837377747484"
                     v-model="formData.offlineContractNumber"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <!--预付合同-->
      <Form :model="formData"
            v-else
            label-position="top"
            ref="form1"
            :rules="rules">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="count"
                      label="总调用次数（只能为整数）">
              <v-format-input type="text"
                     placeholder="输入数字，例如10000"
                     v-model="formData.count">
                <span slot="append">次</span>
              </v-format-input>
            </FormItem>
          </Col>
          <!--<Col span="12">
            <FormItem prop="qps" label="QPS限额">
              <Select v-model="formData.qps"
                      transfer
                      placeholder="请选择最大QPS限额">
                <Option value="1">1</Option>
                <Option value="5">5</Option>
                <Option value="10">10</Option>
                <Option value="20">20</Option>
              </Select>
            </FormItem>
          </Col>-->
          <Col span="12">
            <FormItem prop="startTime" label="服务开始时间">
              <DatePicker style="width: 100%"
                          transfer
                          :options="startTimeOption"
                          v-model="formData.startTime"
                          placeholder="请选择服务开始时间（年-月-日）"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="amount" label="总金额（只能为整数）">
              <v-format-input style="width: 100%"
                     v-model="formData.amount"
                     placeholder="输入数字，例如50000">
                <span slot="append">元整</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="offlineContractNumber" label="线下合同编号">
              <Input type="text"
                     :maxlength="20"
                     placeholder="输入编号，例如TS837377747484"
                     v-model="formData.offlineContractNumber"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </template>
    <!--步骤三-->
    <template v-if="step === 2">
      <CreateTitle :num="1" title="客户信息与服务录入"></CreateTitle>
      <Form :model="formData"
            label-position="top"
            :rules="rules">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="username"
                      label="客户账号">
              <div class="item-value">{{formData.username}}</div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="customerCompany" label="公司备注">
              <div class="item-value">{{formData.customerCompany}}</div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="appId" label="购买服务类型">
              <div class="item-value">
                {{formData.appId | filterListValue(appList, 'id', 'app_name')}}
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="contractType" label="计费方式">
              <div class="item-value">{{contractTypeName}}</div>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <CreateTitle :num="2" :title="secondTitle"></CreateTitle>
      <!--免费合同-->
      <Form :model="formData"
            v-if="formData.contractType === 'FREE'"
            label-position="top"
            ref="form1">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="count" label="总调用次数">
              <div class="item-value">1000</div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="qps" label="QPS限额">
              <div class="item-value">1</div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="startTime" label="服务开始时间">
              <div class="item-value">{{formData.startTime | formatDate('YYYY-MM-DD')}}</div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="amount" label="总金额">
              <div class="item-value">N/A</div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="offlineContractNumber" label="线下合同编号">
              <div class="item-value">
                {{formData.offlineContractNumber}}
                <span class="no-value" v-if="!formData.offlineContractNumber">暂无合同编号</span>
              </div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="40">
          <Col span="24">
            <FormItem prop="reasonForTrial" label="申请试用原因">
              <div class="item-value">{{formData.reasonForTrial}}</div>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <!--月结合同-->
      <Form :model="formData"
            v-else-if="formData.contractType === 'MONTHLY'"
            label-position="top"
            :rules="rules">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="count"
                      label="每月调用次数">
              <div class="item-value">
                {{formData.count}}
                <span>次</span>
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="qps" label="QPS限额">
              <div class="item-value">
                {{formData.qps}}
              </div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="startTime" label="服务开始时间">
              <div class="item-value">
                {{getTimeData()[0] | formatDate('YYYY-MM-DD')}}
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="month" label="持续月份">
              <div class="item-value">
                {{formData.month}}
                <span>月</span>
              </div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="payment" label="每月套餐费用">
              <div class="item-value">
                {{formData.amount}}
                <span>元整</span>
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="excessFees" label="超额单次费用">
              <div class="item-value">
                {{formData.excessFees}}
                <span>元/次</span>
              </div>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem prop="offlineContractNumber" label="线下合同编号">
              <div class="item-value">
                {{formData.offlineContractNumber}}
                <span class="no-value" v-if="!formData.offlineContractNumber">暂无合同编号</span>
              </div>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <!--预付合同-->
      <Form :model="formData"
            v-else
            label-position="top"
            ref="form1"
            :rules="rules">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="count"
                      label="总调用次数">
              <div class="item-value">
                {{formData.count}}
                <span>次</span>
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="qps" label="QPS限额">
              <div class="item-value">1</div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="startTime" label="服务开始时间">
              <div class="item-value">
                {{formData.startTime | formatDate('YYYY-MM-DD')}}
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="amount" label="总金额">
              <div class="item-value">
                {{formData.amount}}
                <span>元整</span>
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="offlineContractNumber" label="线下合同编号">
              <div class="item-value">
                {{formData.offlineContractNumber}}
                <span class="no-value" v-if="!formData.offlineContractNumber">暂无合同编号</span>
              </div>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </template>
    <!--变更合同-->
    <template v-if="step === 3">
      <CreateTitle :num="1" title="客户信息与服务录入"></CreateTitle>
      <!--月结合同-->
      <Form :model="formData"
            label-position="top">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="username"
                      label="客户账号">
              <div class="item-value">{{formData.username}}</div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="customerCompany" label="公司备注">
              <div class="item-value">{{formData.customerCompany}}</div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="appId" label="购买服务类型">
              <div class="item-value">
                {{formData.appId | filterListValue(appList, 'id', 'app_name')}}
              </div>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="contractType" label="计费方式">
              <div class="item-value">{{contractTypeName}}</div>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <CreateTitle :num="2" title="月结模式详情"></CreateTitle>
      <Form :model="formData"
            label-position="top"
            ref="form3"
            :rules="rules">
        <Row :gutter="40">
          <Col span="12">
            <FormItem prop="count"
                      label="每月调用次数（只能为整数）">
              <v-format-input v-model="formData.count"
                              type="text"
                              placeholder="输入数字，例如10000">
                <span slot="append">次</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="qps" label="QPS限额">
              <Select v-model="formData.qps"
                      transfer
                      placeholder="请选择最大QPS限额">
                <Option value="1">1</Option>
                <Option value="5">5</Option>
                <Option value="10">10</Option>
                <Option value="20">20</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="startTime"
                      label="服务开始时间">
              <DatePicker style="width: 100%"
                          type="month"
                          transfer
                          :options="monthStartTimeOption"
                          v-model="formData.startTime"
                          placeholder="请选择服务开始时间（年-月）"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="month" label="持续月份">
              <v-format-input type="text"
                              placeholder="请输入持续月份"
                              v-model="formData.month">
                <span slot="append">月</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="amount" label="总金额（只能为整数）">
              <v-format-input style="width: 100%"
                              format="positiveIntegerAndZero"
                              v-model="formData.amount"
                              placeholder="输入数字，例如50000">
                <span slot="append">元整</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="excessFees" label="超额单次费用（可以有小数）">
              <v-format-input format="money"
                              v-model="formData.excessFees"
                              placeholder="输入数字，例如1.1">
                <span slot="append">元/次</span>
              </v-format-input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="offlineContractNumber" label="线下合同编号">
              <Input type="text"
                     placeholder="输入编号，例如TS837377747484"
                     v-model="formData.offlineContractNumber"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </template>
  </ContractCreateWrapper>
</template>

<script>
import ContractCreateWrapper from '@/components/b-components/contractCreateWrapper/contractCreateWrapper.vue';
import { checkUserExist } from '@/api/user/user';
import {
  getAppList,
} from '@/api/application/service';
import { contractTypeList } from '@/config/enum.config';
import moment from 'moment';
import {
  getContractDetail, createFreeContract, createMonthContract, createPrePayContract,
  validateMonthly, updateContract, validateFree, updateMonthContract,
} from '@/api/settlement/contract';
import CreateTitle from './createTitle.vue';

export default {
  name: 'create',
  components: {
    ContractCreateWrapper,
    CreateTitle,
  },
  data() {
    const validateUsername = async (rule, value, callback) => {
      this.usernameLoading = true;
      const res = await checkUserExist({
        customer_account: value,
        role: 'customer',
      });
      this.usernameLoading = false;
      if (res && !res.exists) {
        callback(new Error('账户不存在，请确认后重新输入'));
      } else {
        this.customerId = res.customer_id;
        callback();
      }
    };
    return {
      formData: {
        contractType: '',
        username: '',
        customerCompany: '',
        appId: '',
        startTime: '',
        month: '',
        count: '',
        amount: '',
        qps: '',
        excessFees: '',
      },
      step: 0,
      usernameLoading: false,
      customerId: '',
      contractTypeList,
      appList: [],
      loading: false,
      contractId: '',
      status: '',
      monthStartTimeOption: {
        disabledDate(date) {
          return date && date.valueOf() < moment().subtract(1, 'M').add(1, 'd').valueOf();
        },
      },
      startTimeOption: {
        disabledDate(date) {
          return date && date.valueOf() < moment().add(1, 'D').valueOf();
        },
      },
      rules: {
        username: [
          { required: true, message: '请输入客户账号', trigger: 'blur' },
          { validator: validateUsername, trigger: 'blur' },
        ],
        customerCompany: [
          { required: true, message: '请输入公司信息', trigger: 'blur' },
        ],
        appId: [
          {
            required: true, message: '请选择购买服务类别', trigger: 'blur', type: 'number',
          },
        ],
        contractType: [
          { required: true, message: '请选择计费方式', trigger: 'blur' },
        ],
        startTime: [
          {
            required: true, message: '请选择服务开始时间', trigger: 'blur', type: 'date',
          },
        ],
        month: [
          { required: true, message: '请输入持续月份', trigger: 'blur' },
        ],
        count: [
          { required: true, message: '请输入调用次数', trigger: 'blur' },
        ],
        amount: [
          { required: true, message: '请输入总金额', trigger: 'blur' },
        ],
        qps: [
          { required: true, message: '请选择最大QPS', trigger: 'blur' },
        ],
        excessFees: [
          { required: true, message: '请输入超额单次费用', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    nextIsDisabled() {
      const {
        username, customerCompany, appId, contractType,
        startTime, month, count, qps, amount, excessFees,
      } = this.formData;
      switch (this.step) {
        case 0:
          return !(username && customerCompany && appId && contractType && this.customerId);
        case 1:
          switch (contractType) {
            case 'MONTHLY':
              return !(startTime && month && count && qps && amount && excessFees);
            case 'PREPAID':
              return !(startTime && count && amount);
            case 'FREE':
              return !startTime;
            default:
              return true;
          }
        case 2:
          return false;
        case 3:
          return !(startTime && month && count && qps && amount && excessFees);
        default:
          return false;
      }
    },
    nextName() {
      if (this.step >= 2) {
        return '提交';
      }
      return '下一步';
    },
    secondTitle() {
      switch (this.formData.contractType) {
        case 'FREE':
          return '免费试用';
        case 'PREPAID':
          return '预付模式详情';
        case 'MONTHLY':
          return '月结模式详情';
        default:
          return '';
      }
    },
    contractTypeName() {
      if (this.formData.contractType) {
        return contractTypeList.find((item) => item.key === this.formData.contractType).value;
      }
      return '';
    },
    contractNum() {
      return this.$route.query.num;
    },
    title() {
      if (this.step === 3) {
        return '合同变更申请';
      }
      if (this.contractId) {
        return '修改合同';
      }
      return '提交新合同';
    },
  },
  created() {
    this.getAppList();
    this.getContractDetail();
  },
  methods: {
    async getAppList() {
      const res = await getAppList();
      if (res) {
        this.appList = res;
      }
    },
    async getContractDetail() {
      if (this.contractNum) {
        this.loading = true;
        const res = await getContractDetail({
          id: this.contractNum,
        });
        if (res) {
          res[0].start_time = res[0].start_time.replace(/-/g, "/");
          const {
            customer_id, customer_company, app_id, id, status,
            start_time, end_time, count, qps, amount, customer_username,
            offline_contract_number, excess_fees, contract_type, reason_for_trial,
          } = res[0];
          this.customerId = customer_id;
          this.contractId = id;
          let startDate = null;
          let endDate = null;
          let month = 0;
          this.status = status;
          switch (contract_type) {
            case 'MONTHLY':
              startDate = moment(start_time).startOf('month');
              endDate = moment(end_time).add(1, 'days');
              while (startDate.format('YYYY-MM-DD') < endDate.format('YYYY-MM-DD')) {
                startDate = startDate.add(month, 'M');
                month += 1;
              }
              if (['ONGOING', 'INCHANGE'].indexOf(status) > -1) {
                this.monthStartTimeOption = {
                  disabledDate(date) {
                    return date
                      && (date.valueOf() < moment().add(1, 'd').valueOf()
                        || date.valueOf() > moment(start_time).add(month - 2, 'M').valueOf());
                  },
                };
                this.step = 3;
              }

              this.formData = {
                contractType: contract_type,
                customerCompany: customer_company,
                username: customer_username,
                appId: app_id,
                startTime: null,
                month: String(month - 1),
                count: String(count),
                qps: String(qps),
                amount: String(amount),
                offlineContractNumber: offline_contract_number,
                excessFees: String(excess_fees),
              };
              break;
            case 'PREPAID':
              this.formData = {
                contractType: contract_type,
                customerCompany: customer_company,
                username: customer_username,
                appId: app_id,
                startTime: new Date(start_time),
                count: String(count),
                amount: String(amount),
                offlineContractNumber: offline_contract_number,
              };
              break;
            case 'FREE':
              this.formData = {
                contractType: contract_type,
                customerCompany: customer_company,
                username: customer_username,
                appId: app_id,
                startTime: new Date(start_time),
                reasonForTrial: reason_for_trial,
              };
              break;
            default:
              break;
          }
        }
        this.loading = false;
      }
    },
    handlePrevStep() {
      if (this.step === 1) {
        this.$refs.form1.fields.forEach(f => f.resetField());
        Object.assign(this.formData, {
          startTime: '',
          month: '',
          count: '',
          amount: '',
          qps: '',
          excessFees: '',
        });
      }
      this.step -= 1;
    },
    async handleSubmit() {
      let valid = false;
      const {
        contractType,
      } = this.formData;
      let res = false;
      switch (this.step) {
        case 0:
          valid = await this.$refs.form0.validate();
          if (valid) {
            if (this.formData.contractType === 'FREE') {
              res = await this.validateFree();
              if (typeof res === 'boolean') {
                this.step += 1;
              } else {
                this.$Message.error('该客户已经体验过此服务类型，无法再享受此服务的免费试用');
              }
              return false;
            }
            this.step += 1;
          }
          break;
        case 1:
          valid = await this.$refs.form1.validate();
          if (valid) {
            if (this.formData.contractType === 'MONTHLY') {
              res = await this.validateMonthly();
              if (res) {
                this.step += 1;
              }
              return false;
            }
            this.step += 1;
          }
          break;
        case 2:
          // 修改合同
          if (this.contractId) {
            let data = {};
            switch (contractType) {
              case 'MONTHLY':
                data = this.monthData();
                break;
              case 'PREPAID':
                data = this.prepayData();
                break;
              case 'FREE':
                data = this.freeData();
                break;
              default:
                break;
            }
            data.id = this.contractId;
            data.contract_type = contractType;
            this.loading = true;
            res = await updateContract(data);
            if (res) {
              this.$Message.success('操作成功');
              this.$router.push({
                name: 'dashboard-settlement-contract',
              });
            }
            this.loading = false;
            return false;
          }
          // 新增合同
          this.loading = true;
          switch (contractType) {
            case 'MONTHLY':
              res = await createMonthContract(this.monthData());
              break;
            case 'PREPAID':
              res = await createPrePayContract(this.prepayData());
              break;
            case 'FREE':
              res = await createFreeContract(this.freeData());
              break;
            default:
              break;
          }
          this.loading = false;
          if (res) {
            this.$Message.success('操作成功');
            this.$router.push({
              name: 'dashboard-settlement-contract',
            });
          }
          break;
        case 3:
          // 修改合同
          if (this.contractId) {
            let data = {};
            switch (contractType) {
              case 'MONTHLY':
                data = this.monthData();
                break;
              case 'PREPAID':
                data = this.prepayData();
                break;
              case 'FREE':
                data = this.freeData();
                break;
              default:
                break;
            }
            data.id = this.contractId;
            data.contract_type = contractType;
            this.loading = true;
            res = await updateMonthContract({
              ...this.monthData(),
              id: this.contractId,
            });
            if (res) {
              this.$Message.success('操作成功');
              this.$router.push({
                name: 'dashboard-settlement-contract',
              });
            }
            this.loading = false;
            return false;
          }
          break;
        default:
          break;
      }
      return false;
    },
    // 验证月结合同开始日期
    async validateMonthly() {
      this.loading = true;
      const {
        customerCompany, appId,
        count, qps, amount, offlineContractNumber,
      } = this.formData;
      const [newStartTime, newEndTime] = this.getTimeData();
      const res = await validateMonthly({
        customer_id: this.customerId,
        customer_company: customerCompany,
        app_id: appId,
        start_time: `${moment(newStartTime).format('YYYY-MM-DD')} 00:00:00`,
        end_time: `${moment(newEndTime).format('YYYY-MM-DD')} 23:59:59`,
        count,
        qps,
        amount,
        offline_contract_number: offlineContractNumber,
        contract_id: this.contractId || undefined,
      });
      this.loading = false;
      return res;
    },
    // 验证免费使用是否合法
    async validateFree() {
      this.loading = true;
      const {
        customerCompany, appId,
      } = this.formData;
      const res = await validateFree({
        contract_id: this.contractId || undefined,
        customer_id: this.customerId,
        customer_company: customerCompany,
        app_id: appId,
      });
      this.loading = false;
      return res;
    },
    // 创建月结合同数据
    monthData() {
      const {
        customerCompany, appId, excessFees,
        count, qps, amount, offlineContractNumber,
      } = this.formData;
      const [newStartTime, newEndTime] = this.getTimeData();
      return {
        customer_id: this.customerId,
        customer_company: customerCompany,
        app_id: appId,
        start_time: `${moment(newStartTime).format('YYYY-MM-DD')} 00:00:00`,
        end_time: `${moment(newEndTime).format('YYYY-MM-DD')} 23:59:59`,
        count: window.parseInt(count),
        qps,
        amount: window.parseInt(amount),
        offline_contract_number: offlineContractNumber,
        excess_fees: excessFees,
      };
    },
    // 创建预付合同数据
    prepayData() {
      const {
        customerCompany, appId, startTime,
        count, amount, offlineContractNumber,
      } = this.formData;
      return {
        customer_id: this.customerId,
        customer_company: customerCompany,
        app_id: appId,
        start_time: `${moment(startTime).format('YYYY-MM-DD')} 00:00:00`,
        count: window.parseInt(count),
        amount: window.parseInt(amount),
        offline_contract_number: offlineContractNumber,
      };
    },
    // 创建免费使用合同数据
    freeData() {
      const {
        customerCompany, appId,
        startTime, reasonForTrial,
        offlineContractNumber,
      } = this.formData;
      return {
        customer_id: this.customerId,
        customer_company: customerCompany,
        app_id: appId,
        start_time: `${moment(startTime).format('YYYY-MM-DD')} 00:00:00`,
        reason_for_trial: reasonForTrial,
        offline_contract_number: offlineContractNumber,
      };
    },
    getTimeData() {
      const {
        startTime, month,
      } = this.formData;
      // 如果是当月，就从明天开始计算，如果是下个月，就从1号开始结算
      let newStartTime = startTime;
      const newEndTime = moment(startTime).add(month, 'months').subtract(1, 'd');
      if (moment(startTime).format('YYYY-MM') === moment().format('YYYY-MM')) {
        newStartTime = moment().add(1, 'd');
      }
      return [
        newStartTime,
        newEndTime,
      ];
    },
  },
};
</script>

<style lang="less">
  .contract-create{
    position: relative;
    .ivu-form{
      padding-left: 56px;
      padding-top: 24px;
      .ivu-form-item-label{
        font-size: 12px;
        color: rgba(0, 0, 0, 0.54);
        padding: 4px 12px 4px 0;
        position: relative;
        &:before{
          font-size: 12px;
          color: rgb(124, 77, 255);
          position: absolute;
          right: 0;
        }
      }
    }
    .ivu-form-item{
      margin-bottom: 48px;
    }
    .ivu-input{
      border-radius: 8px;
      color: rgba(0, 0, 0, 0.87);
      font-weight: 500;
      border-color: rgba(0, 0, 0, 0.12);
      box-shadow: none;
    }
    .ivu-form-item-error{
      .ivu-input{
        border-color: rgb(239, 108, 0);
      }
    }
    .ivu-select{
      color: rgba(0, 0, 0, 0.87);
      font-weight: 500;
      position: relative;
      z-index: 2;
    }
    .ivu-select-selection{
      border-radius: 8px;
      border-color: rgba(0, 0, 0, 0.12);
      box-shadow: none;
      background-color: transparent;
    }
    .ivu-form-item-error-tip{
      font-size: 12px;
      padding-left: 0;
      color: rgb(239, 108, 0);
    }
    .ivu-input-group-append{
      background-color: unset;
      border: none;
    }
    .item-value{
      color: rgba(0, 0, 0, 0.87);
      word-break: break-all;
      span{
        color: rgba(0, 0, 0, 0.54);
        &.no-value{
          color: rgba(0, 0, 0, 0.26);
        }
      }
    }
    .ivu-col-span-12{
      height: 100px;
    }
  }
</style>
